import { render, staticRenderFns } from "./ProcessoCalendario.vue?vue&type=template&id=4e8bb97c&scoped=true"
import script from "./ProcessoCalendario.vue?vue&type=script&lang=js"
export * from "./ProcessoCalendario.vue?vue&type=script&lang=js"
import style0 from "./ProcessoCalendario.vue?vue&type=style&index=0&id=4e8bb97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8bb97c",
  null
  
)

export default component.exports